// extracted by mini-css-extract-plugin
export default {"card":"SectionCard_card__Z8iLb","header":"SectionCard_header__vEeSO","title":"SectionCard_title__AS1zW","actions":"SectionCard_actions__7vtCh","body":"SectionCard_body__4utJP"};